module.exports = __webpack_public_path__ + "static/img/11.f85c65c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/11.jpg
// module id = Vdv8
// module chunks = 1